/** @jsxImportSource solid-js */
export function Spinner() {
  return (
    <>
      <div class="absolute top-0 start-0 size-full bg-brand-900/20 rounded-lg z-50" />

      <div class="absolute top-1/2 start-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <output
          class="animate-spin inline-block size-8 border-[4px] border-current border-t-transparent text-brand-900 rounded-full"
          aria-label="loading"
        >
          <span class="sr-only">Loading...</span>
        </output>
      </div>
    </>
  );
}
